import { library, findIconDefinition } from "@fortawesome/fontawesome-svg-core"

// Whitelist de ícones em vez dos pacotes completos (fas inteiro custava ~800KB no main).
// Os nomes-alias (times, home, cutlery, map-marker-alt...) continuam funcionando: cada ícone
// v6 registra também seus aliases na library.
//
// Ícones dinâmicos vindos da API (promotion.icon dos benefícios, site_show_order do menu)
// são cobertos pelo superset abaixo; para os benefícios há ainda o fallback getSafeIcon().
// Ao adicionar um ícone novo no código, inclua o import aqui — ícone não registrado não
// renderiza (o FontAwesome só loga warning no console).
import {
  faArrowLeft,
  faArrowRight,
  faArrowRotateRight,
  faArrowsRotate,
  faAward,
  faBacon,
  faBagShopping,
  faBan,
  faBeerMugEmpty,
  faBolt,
  faBox,
  faBullhorn,
  faBurger,
  faCakeCandles,
  faCalendarDays,
  faCartShopping,
  faCheck,
  faCheese,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleChevronDown,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlus,
  faCircleUser,
  faCircleXmark,
  faClipboard,
  faClock,
  faCoins,
  faCopy,
  faCreditCard,
  faCrown,
  faDownload,
  faDrumstickBite,
  faEllipsisVertical,
  faFire,
  faFish,
  faForward,
  faGem,
  faGift,
  faHeart,
  faHotdog,
  faHouse,
  faIceCream,
  faKey,
  faLeaf,
  faLemon,
  faLocationDot,
  faLocationPin,
  faMapLocationDot,
  faMartiniGlass,
  faMedal,
  faMinus,
  faMobileScreenButton,
  faMoneyBill,
  faMoneyBillWave,
  faMotorcycle,
  faMugHot,
  faPen,
  faPepperHot,
  faPercent,
  faPhone,
  faPiggyBank,
  faPizzaSlice,
  faPlus,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRocket,
  faRotateRight,
  faSeedling,
  faShare,
  faShieldHalved,
  faShrimp,
  faSpinner,
  faStar,
  faStore,
  faTag,
  faTags,
  faTentArrowLeftRight,
  faThumbsUp,
  faTicket,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faUpload,
  faUser,
  faUserSlash,
  faUtensils,
  faWallet,
  faWineGlass,
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

library.add(
  faArrowLeft,
  faArrowRight,
  faArrowRotateRight,
  faArrowsRotate,
  faAward,
  faBacon,
  faBagShopping,
  faBan,
  faBeerMugEmpty,
  faBolt,
  faBox,
  faBullhorn,
  faBurger,
  faCakeCandles,
  faCalendarDays,
  faCartShopping,
  faCheck,
  faCheese,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleChevronDown,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlus,
  faCircleUser,
  faCircleXmark,
  faClipboard,
  faClock,
  faCoins,
  faCopy,
  faCreditCard,
  faCrown,
  faDownload,
  faDrumstickBite,
  faEllipsisVertical,
  faFire,
  faFish,
  faForward,
  faGem,
  faGift,
  faHeart,
  faHotdog,
  faHouse,
  faIceCream,
  faKey,
  faLeaf,
  faLemon,
  faLocationDot,
  faLocationPin,
  faMapLocationDot,
  faMartiniGlass,
  faMedal,
  faMinus,
  faMobileScreenButton,
  faMoneyBill,
  faMoneyBillWave,
  faMotorcycle,
  faMugHot,
  faPen,
  faPepperHot,
  faPercent,
  faPhone,
  faPiggyBank,
  faPizzaSlice,
  faPlus,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRocket,
  faRotateRight,
  faSeedling,
  faShare,
  faShieldHalved,
  faShrimp,
  faSpinner,
  faStar,
  faStore,
  faTag,
  faTags,
  faTentArrowLeftRight,
  faThumbsUp,
  faTicket,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faUpload,
  faUser,
  faUserSlash,
  faUtensils,
  faWallet,
  faWineGlass,
  faXmark,
  faTimesCircle,
  faWhatsapp
)

// Para ícones configuráveis (benefícios/promos vindos da API): se o nome não estiver
// registrado na whitelist, renderiza "tag" em vez de sumir
export const getSafeIcon = (name, fallback = "tag") => {
  if (!name || typeof name !== "string") return fallback
  return findIconDefinition({ prefix: "fas", iconName: name }) ? name : fallback
}
